import { Image, Text } from 'pcln-design-system'
import React from 'react'
import { StyledSponsor } from '../HeroModule.style'

function SponsoredBy(props) {
  const { url, altText } = props
  return (
    <StyledSponsor alignItems='center' px={4} py={2} borderRadius={'lg'}>
      <Text textAlign='center' color='text.dark' textStyle='heading4' mr={2}>
        Sponsored by:
      </Text>
      <Image alt={altText} src={url} height={40} />
    </StyledSponsor>
  )
}

export default SponsoredBy
